// 微信公众号充值路由
export default [
  // 登录页面
  {
    path: '/',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "wxLogin" */ '@/views/wxWallet/login.vue')
  },
  // 钱包首页
  {
    path: '/home',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "wxHome" */ '@/views/wxWallet/home.vue')
  }
]
